import React from "react";
import { RiCheckFill, RiLoader4Line, RiAlertLine } from "react-icons/ri";

export default function SaveBar({ onSave, isSaving, saveSuccess, saveError, disabled = false }) {
    return (
        <div className="flex items-center justify-between pt-3 border-t border-gray-100 mt-2">
            <div className="flex items-center gap-2 min-h-[20px]">
                {saveSuccess && (
                    <span className="flex items-center gap-1.5 text-xs text-green-600 font-medium animate-fadeIn">
                        <RiCheckFill size={13} />
                        Saved successfully
                    </span>
                )}
                {saveError && (
                    <span className="flex items-center gap-1.5 text-xs text-red-500 font-medium">
                        <RiAlertLine size={13} />
                        {saveError}
                    </span>
                )}
            </div>

            {/* Save button */}
            <button
                type="button"
                onClick={onSave}
                disabled={isSaving || disabled}
                className="flex items-center gap-1.5 bg-[#0226BE] hover:bg-[#021ea8] disabled:opacity-50
                    disabled:cursor-not-allowed text-white px-4 py-2 rounded-lg text-sm font-medium
                    transition-all duration-150 shadow-sm"
            >
                {isSaving ? (
                    <><RiLoader4Line size={14} className="animate-spin" /> Saving…</>
                ) : (
                    <><RiCheckFill size={14} /> Save</>
                )}
            </button>
        </div>
    );
}